export default __webpack_public_path__ + "static/media/phone-fiolet.c01a4006.svg";